import React from 'react';
import EntitiesErrorMessages from '@/components/errors/EntitiesErrorMessages';
import PanelContainer from '@/components/wrappers/PanelContainer';
import { datasetIsDirty } from '../../state/state';
import Selectors from '../hooks/selectors';
import Events from '../../hooks/events';

const CataloguePanelContainer = ({
  category,
  children,
  className,
  code,
  onChange,
}) => {
  const state = Selectors.useCataloguePanelContainer({ category, code });
  const updateProperties = Events.useUpdateDatasetProperties(category, { code });

  return (
    <PanelContainer
      canAccess={state.canRead}
      entity="dataset"
      exists={state.exists}
      isDirty={datasetIsDirty(state)}
      name={state.name}
      onChange={onChange}
      readErrors={state.readErrors}
      readStatus={[state.readStatus, state.templateReadStatus]}
      url={state.url}
    >
      <div className={className}>
        <>
          <EntitiesErrorMessages
            category={category}
            code={code}
            contexts={['fieldUUID']}
            entities={['dataset', 'server']}
            entity="dataset"
            errors={state.saveErrors}
            onDismiss={(errors) => updateProperties({ properties: { saveErrors: errors } })}
          />
          {children}
        </>
      </div>
    </PanelContainer>
  );
};

export default CataloguePanelContainer;
